export const DASH = '\u2014';
